module.exports = __webpack_public_path__ + "img/freek_06.4c88be2f.jpg";